<div
  class="item-icon"
  [class.completed]="completed()"
  [class.pending]="!completed()"
>
  @if (completed()) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM6.24179 9.21158L11.5171 4.23759C11.6174 4.14303 11.7779 4.14303 11.8581 4.23759L12.4398 4.76714C12.5201 4.8617 12.5201 5.013 12.4398 5.08865L6.42232 10.7624C6.32203 10.857 6.18162 10.857 6.08133 10.7624L3.39351 8.24704C3.31327 8.15248 3.31327 8.00118 3.39351 7.92553L3.9752 7.37707C4.05543 7.30142 4.2159 7.30142 4.31619 7.37707L6.24179 9.21158Z"
      fill="#008200"
    />
  </svg>
  } @else {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M8.33333 0C3.72984 0 0 3.72984 0 8.33333C0 12.9368 3.72984 16.6667 8.33333 16.6667C12.9368 16.6667 16.6667 12.9368 16.6667 8.33333C16.6667 3.72984 12.9368 0 8.33333 0ZM8.33333 15.0538C4.6035 15.0538 1.6129 12.0632 1.6129 8.33333C1.6129 4.6371 4.6035 1.6129 8.33333 1.6129C12.0296 1.6129 15.0538 4.6371 15.0538 8.33333C15.0538 12.0632 12.0296 15.0538 8.33333 15.0538ZM10.3831 11.5591C10.5847 11.6935 10.8199 11.6599 10.9543 11.4583L11.5927 10.6183C11.7272 10.4167 11.6935 10.1815 11.4919 10.047L9.27419 8.40054V3.62903C9.27419 3.42742 9.07258 3.22581 8.87097 3.22581H7.7957C7.56048 3.22581 7.39247 3.42742 7.39247 3.62903V9.17339C7.39247 9.27419 7.42608 9.4086 7.52688 9.47581L10.3831 11.5591Z"
      fill="#9C9C9C"
    />
  </svg>
  }
</div>

<div class="item-content">
  <span
    class="item-label"
    [class.completed]="completed()"
    [class.pending]="!completed()"
  >
    {{ label() }}
  </span>

  @if (linkLabel()) {
  <a
    class="item-link"
    (click)="linkClicked.emit()"
    tabindex="0"
    role="button"
  >
    {{ linkLabel() }}
  </a>
  }
</div>
